<script lang="ts" setup>
import HistoryPageDefault from './components/HistoryPage.default.vue'
import { historyCommonConfig, historyDeleteModalTheme } from './configs/common'
import { loadBrandComponent } from '@/utils/loadBrandConfig'

const HistoryPage = loadBrandComponent({
  rocnovel: HistoryPageDefault,
  oceread: HistoryPageDefault,
  ficmoon: HistoryPageDefault,
  novelarc: HistoryPageDefault,
  storyella: HistoryPageDefault,
  silktale: HistoryPageDefault,
  pearla: HistoryPageDefault,
  fictora: HistoryPageDefault,
  marinovel: HistoryPageDefault,
  talewave: HistoryPageDefault,
})
</script>

<template>
  <HistoryPage
    :config="historyCommonConfig"
    :delete-modal-theme="historyDeleteModalTheme"
  />
</template>
